import React from "react"
// function StackerSample(props) {
//   const stackerContext = useContext(StackerContext)
//   return (
//     <div>
//       <button onClick={() => stackerContext.getInstance().onAddToCart('XYZZZ', 3)}>Click Me!</button>
//     </div>
//   )
// }

export const StackerContext = React.createContext({
  // getInstance: () => document.getElementsByTagName('dy-stackers')[0]
  getInstance: () => ({}),
  retailerId:
    document.querySelector("dy-stackers")?.getAttribute("retailer-id") || "",
  lang: "en",
  gender:
    document.querySelector("dy-stackers")?.getAttribute("gender") || "women",
})
StackerContext.displayName = "StackerContext"
